import styled from 'styled-components';

export const CenteredWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
`;

export const ValueMappingMissingValueRowWrapper = styled.div`
	padding-top: 1rem;
	padding-left: 1rem;
`;
